import React, { useContext } from "react";
import { chargingConfig, ConfigResponse } from '@/config';

export const ConfigContext = React.createContext<ConfigResponse>(chargingConfig as ConfigResponse);

export const ConfigProvider = ({ children }) => {
    return (
        <ConfigContext.Provider value={chargingConfig}>{children}</ConfigContext.Provider>
    );
};

export default function useConfig() {
    return useContext(ConfigContext);
}
